import { render, staticRenderFns } from "./App.vue?vue&type=template&id=50d19770&"
import script from "./App.vue?vue&type=script&lang=coffee&"
export * from "./App.vue?vue&type=script&lang=coffee&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports